import { createFileRoute } from "@tanstack/react-router";

import YearlyPage from "@/admin/reports/yearly/page";

export const Route = createFileRoute("/app/$storeId/reports/yearly")({
    component: RouteComponent,
});

function RouteComponent() {
    return <YearlyPage />;
}
